import { useRef, useEffect } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import tImg1 from '../../../images/avatar/5.png'
import tImg2 from '../../../images/avatar/6.png'
import tImg3 from '../../../images/avatar/7.png'

import clogo1 from '../../../images/privacy/green.png'
import clogo2 from '../../../images/privacy/stratton.png'
import clogo3 from '../../../images/privacy/bidaHomes.png'



const testimonial = [
    {
        id: '01',
        tImg: tImg1,
        Title: 'Green Bell Packaging',
        Des: "As one of the UK’s leading sustainable packaging providers, Green Bell Packaging has significantly benefited from our collaboration with Laskon Technologies. Their team played a crucial role in streamlining our R&D processes and enhancing our innovation pipeline. Laskon’s ability to understand our vision and translate it into scalable, tech-driven solutions has made a tangible difference in how we develop and deliver next-generation packaging.",
        Name: 'V nagori',
        sub: 'CEO Founder',
        country: 'Liverpool, UK',
        clogo: clogo1,
    },
    {
        id: '02',
        tImg: tImg2,
        Title: 'Stratton Tea',
        Des: "Laskon Technologies has been a pivotal move for Stratton Tea. Their strategic and tech-driven approach has helped us identify high-value potential leads and expand our market reach with precision. More importantly, their team has provided consistent support in building the digital and operational backbone for our two upcoming tea and coffee brands. From market insights to technical execution, they’ve been instrumental in ensuring a strong foundation for our next phase of growth.",
        Name: 'Razi K',
        sub: 'CEO Founder',
        country: 'Liverpool, UK',
        clogo: clogo2,
    },
    {
        id: '03',
        tImg: tImg3,
        Title: 'Bida Homes & Construction',
        Des: "Laskon Technologies has brought a powerful digital edge to our real estate and construction operations. Their tailored tech solutions helped us attract qualified leads, improve client engagement, and optimize the way we present our projects online. From virtual property showcases to CRM integration and automation, their support has resulted in faster deal closures and a more streamlined buyer journey. They understand the real estate space deeply and deliver results that matter.",
        Name: 'Andrew T',
        sub: 'CEO Founder, Bida Home',
        country: 'Africa, Ghana',
        clogo: clogo3,
    },
]

const Testimonial = () => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current && prevRef.current && nextRef.current) {
            swiperRef.current.params.navigation.prevEl = prevRef.current;
            swiperRef.current.params.navigation.nextEl = nextRef.current;
            swiperRef.current.navigation.init();
            swiperRef.current.navigation.update();
        }
    }, []);

    return (

        <div className="row">
            <div className="col-lg-4">
                <div className="deals_winner_customers">
                    <video
                        src={require('../../../images/video/laskon.mp4')}
                        autoPlay
                        muted
                        loop
                        playsInline
                        style={{ width: '100%', height: 'auto', borderRadius: '12px' }}
                    />
                    {/* <h3 className="title_text hidden">
                        <mark>3,900+</mark> customers win deals with Techco
                    </h3> */}
                    {/* <div className="row">
                        <div className="col-6">
                            <div className="review_short_info">
                                <div className="icon">
                                    <img src={icon1} alt="C SVG Icon" />
                                </div>
                                <ul className="rating_block unordered_list">
                                    <li><i className="fa-solid fa-star fa-fw"></i></li>
                                    <li><i className="fa-solid fa-star fa-fw"></i></li>
                                    <li><i className="fa-solid fa-star fa-fw"></i></li>
                                    <li><i className="fa-solid fa-star fa-fw"></i></li>
                                    <li><i className="fa-solid fa-star fa-fw"></i></li>
                                </ul>
                                <div className="review_counter">From <b>200+</b> reviews</div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="review_short_info">
                                <div className="icon">
                                    <img src={icon2} alt="C SVG Icon" />
                                </div>
                                <ul className="rating_block unordered_list">
                                    <li><i className="fa-solid fa-star fa-fw"></i></li>
                                    <li><i className="fa-solid fa-star fa-fw"></i></li>
                                    <li><i className="fa-solid fa-star fa-fw"></i></li>
                                    <li><i className="fa-solid fa-star fa-fw"></i></li>
                                    <li><i className="fa-solid fa-star fa-fw"></i></li>
                                </ul>
                                <div className="review_counter">From <b>300+</b> reviews</div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className="col-lg-8">
                <div className="review_onecol_wrapper">
                    <div className="review_onecol_carousel">
                        <Swiper
                            // install Swiper modules
                            modules={[Navigation]}
                            spaceBetween={50}
                            slidesPerView={1}
                            loop={true}
                            speed={1800}
                            parallax={true}
                            ref={swiperRef}
                            onBeforeInit={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                        >
                            {testimonial.map((testimonial, tsm) => (
                                <SwiperSlide key={tsm}>
                                    <div className="review_block_2">
                                        <h3 className="review_title">“{testimonial.Title}”</h3>
                                        <p className="review_commtent">
                                            {testimonial.Des}
                                        </p>
                                        <div className="d-md-flex justify-content-md-between">
                                            <div className="review_admin">
                                                <div className="review_admin_image" style={{ width: "110px" }}>
                                                    <img src={testimonial.tImg} width="110"
                                                        height="110" alt={testimonial.Name || "Reviewer Image"} />
                                                </div>
                                                <div className="review_admin_info">
                                                    <h4 className="review_admin_name">{testimonial.Name}</h4>
                                                    <span className="review_admin_designation">{testimonial.sub}</span>
                                                    <div className="review_admin_country">
                                                        {/* <span className="country_flag">
                                                            <img src={flag} alt="Ukraine Flag" />
                                                        </span> */}
                                                        <span className="country_text">{testimonial.country}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="review_admin_logo">
                                                <img src={testimonial.clogo} alt="Review Admin Logo" />
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>


                        <div className="carousel_arrows_nav">
                            <button ref={prevRef} type="button" className="r1cc-swiper-button-prev" aria-label="Previous testimonial">
                                <i className="fa-solid fa-arrow-left"></i>
                            </button>
                            <button ref={nextRef} type="button" className="r1cc-swiper-button-next" aria-label="Next testimonial">
                                <i className="fa-solid fa-arrow-right"></i>
                            </button>
                        </div>




                    </div>
                </div>
            </div>
        </div>
    );
}

export default Testimonial;